const o = "_triggerRoot_1u9ox_1", r = "_fullWidth_1u9ox_54", t = "_isIcon_1u9ox_58", _ = "_small_1u9ox_65", a = "_large_1u9ox_68", n = {
  triggerRoot: o,
  "button-primary-brand": "_button-primary-brand_1u9ox_22",
  "button-primary-gray": "_button-primary-gray_1u9ox_25",
  "button-secondary-gray": "_button-secondary-gray_1u9ox_28",
  "hover-secondary-blue": "_hover-secondary-blue_1u9ox_32",
  "hover-secondary-gray": "_hover-secondary-gray_1u9ox_43",
  fullWidth: r,
  isIcon: t,
  small: _,
  large: a
};
export {
  n as default,
  r as fullWidth,
  t as isIcon,
  a as large,
  _ as small,
  o as triggerRoot
};
//# sourceMappingURL=index.es777.js.map
